// extracted by mini-css-extract-plugin
var _1 = "Skeleton-moduleavatar__lKbh6";
var _2 = "Skeleton-modulecontainer__uq_kD";
var _3 = "Skeleton-modulecontent__t4uI9";
export { _1 as "avatar", _2 as "container", _3 as "content" }
